export default __webpack_public_path__ + "static/media/open-sound.15057a5c.wav";